/* Les Beads · NT-08 "Ver más" en colecciones.
 * Progressive enhancement: sin JS el enlace lleva a ?page=N (paginador clásico).
 * Con JS se pide la siguiente página con Section Rendering API y se añaden los
 * productos a la rejilla. Compatible con los filtros AJAX del tema (Filterable
 * reemplaza #results completo y este elemento se vuelve a inicializar solo). */
(() => {
  if (customElements.get('lb-load-more')) return;

  // Tras filtrar por AJAX, paginate.next.url puede arrastrar section_id: lo quitamos para navegación normal.
  const cleanHref = (href) => {
    const url = new URL(href, window.location.origin);
    url.searchParams.delete('section_id');
    return url.toString();
  };

  class LbLoadMore extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[data-lb-load-more-link]');
      this.setAttribute('data-ready', '');
      if (!this.link) return;
      this.link.href = cleanHref(this.link.href);
      this.onClick = this.onClick.bind(this);
      this.link.addEventListener('click', this.onClick);
      this.setupInfinite();
    }

    disconnectedCallback() {
      if (this.link) this.link.removeEventListener('click', this.onClick);
      if (this.observer) this.observer.disconnect();
    }

    // Scroll infinito (ajuste de sección "Loading more products"): carga sola al acercarse al final
    // hasta data-auto-max páginas (0 = sin límite); después queda el botón para poder llegar al footer.
    setupInfinite() {
      if (this.dataset.mode !== 'infinite' || !('IntersectionObserver' in window)) return;
      const results = this.closest('[data-fragment-id="results"]') || document;
      const list = results.querySelector('[data-lb-list]');
      const max = parseInt(this.dataset.autoMax || '0', 10);
      const done = list ? parseInt(list.dataset.lbAuto || '0', 10) : 0;
      if (!list || (max > 0 && done >= max)) return;
      this.classList.add('is-infinite');
      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting) || this.busy) return;
        this.observer.disconnect();
        list.dataset.lbAuto = String(done + 1);
        this.auto = true;
        this.onClick();
      }, { rootMargin: '0px 0px 600px 0px' });
      this.observer.observe(this);
    }

    async onClick(event) {
      if (event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
        event.preventDefault();
      }
      if (this.busy) return;

      const results = this.closest('[data-fragment-id="results"]') || document;
      const list = results.querySelector('[data-lb-list]');
      const pager = this.closest('[data-lb-pager]');
      if (!list || !pager) {
        window.location.href = this.link.href;
        return;
      }

      this.busy = true;
      this.link.setAttribute('aria-busy', 'true');
      this.classList.add('is-loading');

      try {
        const url = new URL(this.link.href, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url.toString());
        if (!response.ok) throw new Error(response.status);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

        const newList = doc.querySelector('[data-lb-list]');
        const newItems = newList ? [...newList.querySelectorAll(':scope > [data-lb-item]')] : [];
        if (!newItems.length) throw new Error('empty');

        // Quitar huecos de relleno de la última fila y usar los de la nueva página.
        list.querySelectorAll(':scope > li[aria-hidden="true"]').forEach((el) => el.remove());
        const fragment = document.createDocumentFragment();
        newList.querySelectorAll(':scope > li').forEach((li) => fragment.appendChild(document.adoptNode(li)));
        list.appendChild(fragment);

        const newPager = doc.querySelector('[data-lb-pager]');
        if (newPager) {
          const adopted = document.adoptNode(newPager);
          pager.replaceWith(adopted);
        } else {
          pager.remove();
        }

        // Accesibilidad: llevar el foco al primer producto nuevo (sin salto brusco).
        // (solo con clic: en scroll infinito mover el foco interrumpiría la lectura)
        const firstLink = newItems[0].querySelector('a[href]');
        if (firstLink && !this.auto) firstLink.focus({ preventScroll: true });
      } catch (error) {
        if (this.auto) {
          // En automático no se navega: se deja el botón para reintentar a mano.
          this.busy = false;
          this.link.removeAttribute('aria-busy');
          this.classList.remove('is-loading', 'is-infinite');
          return;
        }
        window.location.href = this.link.href;
      }
    }
  }

  customElements.define('lb-load-more', LbLoadMore);
})();
